<template>
  <div>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/mail/accounts/index' }">授权帐号列表</el-breadcrumb-item>
      <el-breadcrumb-item>{{ form.id <= 0 ? '添加' : '编辑'}}授权帐号</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="content_box">
      <div class="content">
        <el-form :model="form" ref="ruleForm" :rules="rules" label-width="160px">
          <el-form-item label="邮箱" prop="email">
            <el-col :span="12">
              <el-input size="small" v-model="form.email" placeholder="请输入邮箱"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="授权码" prop="auth_code">
            <el-col :span="12">
              <el-input size="small" v-model="form.auth_code" placeholder="请输入授权码"></el-input>
            </el-col>
          </el-form-item>

          <el-form-item>
            <el-button size="small" type="primary" @click="save">保存</el-button>
            <el-button size="small" @click="$router.go(-1)">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      form: {
        id: '',
        email: '',
        auth_code: ''
      },
      rules: {
        email: [
          { type: 'email', required: true, message: '请输入邮箱', trigger: 'blur' },
        ],
        auth_code: [
          {  required: true, message: '请输入授权码', trigger: 'blur' },
          { min: 1, max: 255, message: '授权码长度在1到255个字符', trigger: 'blur' }
        ],
      }
    };
  },
  methods: {
    loadAccount() {
      var id = this.$route.query ? this.$route.query.id : 0;
      if(!id) {
        return 0
      }

      this.$ajax({
        url: "/email/accounts/one?id=" + id,
        type:"GET",
      }).then(res => {
        this.form = {
          id: res.data.id,
          email: res.data.email,
          auth_code: res.data.auth_code
        }
      });
    },
    save() {
      let form = this.form;
      this.$refs.ruleForm.validate((valid) => {
        if(!valid) {
          return false;
        }

        // 开始处理loading.
        var loading = this.$loading({
          lock: true,
          text: '保存中...',
          spinner: 'el-icon-loading',
          background: 'hsla(0,0%,100%,.9)',
        });

        this.$ajax({
          type: 'POST',
          url: '/email/accounts/save',
          data: form,
        }).then((res) => {
          loading.close()
          if(res.code != 200) {
            return this.$util.msg(res.msg, "error");
          }
          
          this.$util.msg(res.msg, "success");

          setTimeout(() => {
            this.$router.push({ path: "/mail/accounts/index" });
          });
        })
      });

      return false;
    }
  },
  mounted() {
    this.loadAccount()
  }
};
</script>
<style>
</style>